export default __webpack_public_path__ + "static/cafeterabg1_7-f9cd8893a5d599c7e924842d755ee5a3.png";